import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeposit = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.09198 0L5.09198 10",
		stroke: "#1E63FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 5.09277L2.38419e-07 5.09277",
		stroke: "#1E63FF"
	})]
});
export default SvgDeposit;
